import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { trackEvent } from '../../../Analytics/TrackedClick';
import { statsAnalyticsEvents, getPerformanceStatsEngagementTraits } from '../../../../utils/analytics';

// Read from redux rather than taking props: PlayerRow is five levels below
// PerformanceStats and shared by four render paths, so drilling a callback
// would touch every component in between.
const usePerformanceStatsEngagement = () => {
    const auth = useSelector(({ auth: authState }) => authState);
    const profilePlayerId = useSelector(({ profile }) => profile?.data?.id);

    return useCallback((engagementType, opponentPlayerId = null) => {
        trackEvent(
            statsAnalyticsEvents.PERFORMANCE_STATS_ENGAGEMENT,
            getPerformanceStatsEngagementTraits(auth, profilePlayerId, engagementType, opponentPlayerId),
        );
    }, [auth, profilePlayerId]);
};

export default usePerformanceStatsEngagement;
